import { render, staticRenderFns } from "./RSQViolenceForm3.vue?vue&type=template&id=e4599b7c&"
import script from "./RSQViolenceForm3.vue?vue&type=script&lang=js&"
export * from "./RSQViolenceForm3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports